import { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import { useLanguage } from '../../context/LanguageContext';
import { clinicInfo } from '../../data/mock-allgemein';
import usePageSEO from '../../hooks/usePageSEO';
import { StartNav } from './StartNav';
import { StartHero } from './StartHero';
import { TreatmentStack } from './TreatmentStack';
import { StartTechniques } from './StartTechniques';
import { StartClinic } from './StartClinic';
import { StartFinalCta, StartFooter } from './StartSections';
import { startCopy } from './startCopy';
import './start.css';

export default function StartPage() {
  const { language } = useLanguage();
  const copy = startCopy[language === 'en' ? 'en' : 'de'];
  const canonical = `https://${clinicInfo.website}/start`;
  usePageSEO({
    title: copy.seo.title,
    description: copy.seo.description,
    canonical,
    ogTitle: copy.seo.title,
    ogDescription: copy.seo.description,
    ogUrl: canonical,
  });

  useEffect(() => {
    document.documentElement.classList.add('dion-start-active');
    return () => document.documentElement.classList.remove('dion-start-active');
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="dion-start" data-testid="start-page" lang={language}>
        <div id="start-top" data-testid="start-top-anchor" aria-hidden="true" />
        <a className="start-skip" href="#start-main" data-testid="start-skip-link">{copy.nav.skip}</a>
        <StartNav copy={copy} />
        <main id="start-main" tabIndex={-1} data-testid="start-main">
          <StartHero copy={copy} />
          <TreatmentStack copy={copy} />
          <StartTechniques copy={copy} />
          <StartClinic copy={copy} />
          <StartFinalCta copy={copy} />
        </main>
        <StartFooter copy={copy} />
      </div>
    </MotionConfig>
  );
}